import { render } from "./RecommendFoodMenu.vue?vue&type=template&id=5f2d7a5a&scoped=true&ts=true"
import script from "./RecommendFoodMenu.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodMenu.vue?vue&type=script&lang=ts"

import "./RecommendFoodMenu.vue?vue&type=style&index=0&id=5f2d7a5a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2d7a5a"]])

export default __exports__